import {
  defaultAbout,
  defaultProjects,
  defaultProfile,
} from "../constants/const";

const API_BASE = process.env.REACT_APP_API_URL || "";
const USE_API =
  Boolean(process.env.REACT_APP_API_URL) ||
  process.env.REACT_APP_USE_API === "true";

async function fetchJson(path) {
  const res = await fetch(`${API_BASE}${path}`);
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data.error || `Request failed (${res.status})`);
  }

  return data;
}

async function withFallback(fetchFn, fallback) {
  if (!USE_API) {
    return fallback;
  }

  try {
    return await fetchFn();
  } catch (_error) {
    return fallback;
  }
}

export const fetchAbout = () =>
  withFallback(() => fetchJson("/api/portfolio/about"), defaultAbout);

export const fetchProjects = () =>
  withFallback(() => fetchJson("/api/portfolio/projects"), defaultProjects);

export const fetchProfile = () =>
  withFallback(() => fetchJson("/api/portfolio/profile"), defaultProfile);
